import React, { useContext } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { modalNamesFactory } from "../../Helper_functions/Languages/LanguageSelector";
import { LanguageContext } from "../../context/languageContext";
import { type } from "os";
import { LanguageIdContext } from "../../context/languageIdContext";


type buttonBootstrapColors = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" ;

interface Modal_pop_up_int{
    title?:string,
    isOpen:boolean,
    body: React.ReactNode |string
    buttonTitle:string,
    bnt_confirm_onclick:()=>void,
    bnt_cancel_onclick?:()=>void,
    disable?:boolean,
    buttonColor?:buttonBootstrapColors
}




function Modal_pop_up({title,isOpen,body,buttonTitle,bnt_confirm_onclick,bnt_cancel_onclick,disable,buttonColor}:Modal_pop_up_int) {
  const {languageId} = useContext(LanguageIdContext);

  return (
    <Modal
      isOpen={isOpen}
     
    >
      <ModalHeader >{title?title:"Modal title"}</ModalHeader>
      <ModalBody>
        {body}
      </ModalBody>
      <ModalFooter>
        <Button color={
          buttonColor?buttonColor:"primary"
        } onClick={bnt_confirm_onclick} disabled={disable}> 
          {buttonTitle}
        </Button>
       {bnt_cancel_onclick? <Button color="secondary" onClick={bnt_cancel_onclick} >
          {modalNamesFactory(languageId,"Cancel")}
        </Button>:<></>}
      </ModalFooter>
    </Modal>
  );
}

export default Modal_pop_up;
